import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button from '../../../Button'
import { Divider } from '../../../Divider'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_INSERT_PHASE } from '../RequestProfileTabActivities.constants'

import * as styles from './RequestProfileTabActivitiesInsertPhaseDivider.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabActivitiesInsertPhaseDivider({
  position,
  onAddPhase,
}) {
  const { t } = useTranslation()

  function handleClick() {
    onAddPhase(position)
  }

  return (
    <div className={styles.RequestProfileTabActivitiesInsertPhaseDivider}>
      <Divider className={styles.line} />
      <Button.Contained
        isLight
        beforeIconProps={{ Icon: PlusIcon }}
        className={styles.button}
        qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_INSERT_PHASE}
        tooltip={t('RequestProfileTabActivities.InsertPhaseTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={handleClick}
      />
    </div>
  )
}

export default RequestProfileTabActivitiesInsertPhaseDivider
